module.exports = __webpack_public_path__ + "static/media/BIASREPORT.41c1d0bf.png";